import { createFileRoute } from '@tanstack/react-router';
import { Button, rem } from '@mantine/core';
import { IconNotebook, IconPlus } from '@tabler/icons-react';
import { useCallback, useState } from 'react';
import { MaePageHead, MaeShell } from '@/shared/desktop/MaeShell';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { mw } from '@/shared/mobile/tokens';
import { MaeGate } from '@/shared/components/MaeGate';
import { NotesBoard } from '@/features/tasks/NotesBoard';
import { NewActionContext, type NewActionRegistry } from '@/features/tasks/newAction';
import { TASK_NO_CREATE_REASON, useTaskPermissions } from '@/features/tasks/taskPermissions';

/* Pagina a sé dal 21-10-2026: prima era la scheda «Appunti» dei Task. */
export const Route = createFileRoute('/_app/notes')({ component: NotesPage });

function NotesPage() {
  const isMobile = useIsMobileShell();
  const perms = useTaskPermissions();
  /* La board registra cosa apre «Nuovo appunto», come faceva dentro la sezione Task. */
  const [newNote, setNewNote] = useState<(() => void) | null>(null);
  const record = useCallback<NewActionRegistry>((fn) => setNewNote(() => fn), []);

  const board = (
    <NewActionContext.Provider value={record}>
      <NotesBoard />
    </NewActionContext.Provider>
  );

  if (isMobile) {
    return (
      <>
        {board}
        {perms.create && newNote && (
          <button
            className="mw-pressable"
            onClick={newNote}
            style={{ position: 'fixed', right: 18, bottom: 'calc(var(--mw-nav-spazio) + 4px)', zIndex: 190, cursor: 'pointer', border: 0, height: rem(52), padding: '0 22px', borderRadius: 999, background: mw.brandFill, color: 'var(--on-brand)', fontSize: 'var(--fs-lead)', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8, boxShadow: '0 10px 24px -8px rgba(84,4,9,0.5)' }}
          >
            <IconPlus size={20} stroke={2.4} /> Nuovo appunto
          </button>
        )}
      </>
    );
  }

  return (
    <MaeShell fullHeight>
      <MaePageHead
        icon={<IconNotebook size={22} />}
        title="Appunti"
        sub="Note libere: titolo, testo ed etichette, fuori dal flusso dei task."
        actions={(
          // Anche un appunto è un task: stesso claim.
          <MaeGate when={perms.create} mode="disable" reason={TASK_NO_CREATE_REASON}>
            <Button
              leftSection={<IconPlus size={16} />}
              onClick={() => newNote?.()}
              disabled={!perms.create || !newNote}
            >
              Nuovo appunto
            </Button>
          </MaeGate>
        )}
      />
      {board}
    </MaeShell>
  );
}
